import lodash from 'lodash'
import React from 'react'
import { ReactElement } from 'react'
import styled from 'styled-components'

import Input from '../../../../../../../../1stlog-ui/src/components/Input'
import TypeAhead from '../../../../../../../../1stlog-ui/src/components/TypeAhead'
import { request } from '../../../../../../../../1stlog-ui/src/utils'
import useOrderEntry from '../../../../../useOrderEntry'
import { TOrderEntryAutocompleteCustomsItem } from '../../../types'
import Option from './Option'

const Wrapper = styled.div`
  width: 100%;
`

type TCustomsSearchAutocompleteProps = {
  onApplyValues: (values: any) => void
  value?: string
  onChange?: (value: string) => void
  disableAutocomplete?: boolean
}

const CustomsSearchAutocomplete = (
  props: TCustomsSearchAutocompleteProps,
): ReactElement => {
  const {
    onApplyValues = lodash.noop,
    value,
    onChange,
    disableAutocomplete,
  } = props

  const { customsUrl } = useOrderEntry()

  const { currentCustomer } = useOrderEntry()
  // console.log('currentCus', currentCustomer)
  // const [value, setValue] = useState("")

  const requestOptions = async (
    _: any,
    text: string,
  ): Promise<TOrderEntryAutocompleteCustomsItem[]> => {
    try {
      const { data } = await request<TOrderEntryAutocompleteCustomsItem[]>({
        method: 'post',
        url: `${customsUrl}/search`,
        data: {
          text: `${text}`,
          customerId: currentCustomer?.id,
        },
      })
      return lodash.slice(data, 0, 5)
    } catch (err) {
      console.log('Failed to request customs search', err)
      return []
    }
  }

  const renderOption = (
    item: TOrderEntryAutocompleteCustomsItem,
  ): ReactElement => {
    return <Option item={item} />
  }

  // const reset = () => setValue("")

  const setValues = (values: TOrderEntryAutocompleteCustomsItem): void => {
    console.log('setValues customs', values)
    onApplyValues(values)
    // props.setValues(parseValues(values))
    // reset()
  }

  return (
    <Wrapper className="d-flex">
      <div className="flex-fill">
        {disableAutocomplete ? (
          <Input value={value} onChange={onChange} />
        ) : (
          <TypeAhead
            placeholder="Suchen..."
            value={value}
            onChange={onChange}
            requestOptions={requestOptions}
            renderOption={renderOption}
            onSetValues={setValues}
            minLength={1}
          />
        )}
      </div>
    </Wrapper>
  )
}

export default CustomsSearchAutocomplete
